import { Injectable } from "@angular/core";
import { SearchPractitionerResult } from "src/app/ui/models/domains/pbm/practitioner-management/search-practitioner.result";
import { AbstractParser } from "../../parser";
import { parseSearchPractitionerResult } from "./practitioner-management-parse-function";

@Injectable()
export class SearchPractitionersParser extends AbstractParser<SearchPractitionerResult> {
  parse(payload: any): SearchPractitionerResult {
    return parseSearchPractitionerResult(payload);
  }
}
